import { AppThunk } from '../states/generateStore';
import { suiteCrmUrl, getSMSTemplate } from './constants';
import shellSlice from '../states/shell/slice';
import snackBarSlice from '../states/snackbar/slice';

const onGetSMSTemplate = (): AppThunk =>
  async (dispatch, getStore) => {
    const templateId = 'e887fbad-fd6d-00a4-0ec9-60af0f5812fe';
    // Create a fetch call to get sms template
    try {
      const formData = new FormData();
      formData.append('template_id', templateId);

      const response = await fetch(suiteCrmUrl.concat(getSMSTemplate),
        { 
          method: 'POST',
          body: formData
        }
      );
      const result = await response.text();
      if (result) {
        // save to sms template
        dispatch(shellSlice.actions.updateSMSTemplate(result));
      }
    } catch (err) {
      console.log(err);
      // show error
      dispatch(snackBarSlice.actions.updateAlert({message: "onGetSMSTemplate: Can not get data from Server", severity: "error"}));
      dispatch(snackBarSlice.actions.updateSnackBar(true));
    }
  }
export default onGetSMSTemplate;